import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { getReactionSettings } from 'rev-portal/scheduledEvents/webcast/Webcast.Service';
import { lastValueFrom } from 'rev-shared/rxjs/lastValueFrom';
import { parseTimespan } from 'rev-shared/date/DateParsers.Service';
import { UserContextService } from 'rev-shared/security/UserContext.Service';

import { ITemplateMenuService, ITemplate } from 'rev-shared/ui/templates/TemplateMenu.Component';
import { ITemplateInfo } from './WebcastTemplates.Contract';

@Injectable({
	providedIn: 'root'
})
export class WebcastTemplatesService implements ITemplateMenuService {

	constructor(
		private http: HttpClient,
		private UserContext: UserContextService
	) {}

	public getTemplates(accountId?: string): Promise<ITemplate[]> {
		accountId = accountId || this.UserContext.getAccount().id;
		return lastValueFrom<any>(this.http.get(`/scheduled-events/accounts/${accountId}/templates`))
			.then(result => result.templates);
	}

	public getDefaultTemplate(): Promise<ITemplateInfo> {
		return lastValueFrom<any>(this.http.get('/scheduled-events/templates/default'))
			.then(template => {
				if (template) {
					return readTemplateDetail(template);
				}
			});
	}

	public getTemplate(templateId: string): Promise<ITemplateInfo> {
		return lastValueFrom<any>(this.http.get(`/scheduled-events/templates/${templateId}`))
			.then(template => readTemplateDetail(template));
	}


}

function readTemplateDetail(template: ITemplateInfo): ITemplateInfo {
	if(!template) {
		return;
	}
	const metadata = template.metadata;
	if(metadata) {
		if (metadata.preProduction) {
			metadata.preProduction.durationMs = parseTimespan(metadata.preProduction.duration);
		}
		metadata.reactionsSettings = getReactionSettings(metadata.reactionsSettings);
	}
	readVideoInfo(template.vodInfo);
	readVideoInfo(template.preRollVideo);
	readVideoInfo(template.postRollVideo);
	return template;
}

function readVideoInfo(video: any) {
	if(video){
		video.durationMs = parseTimespan(video.duration);
	}
}
